<button
  [ngbPopover]="filterGroupPrefixForm"
  type="button"
  nf-button="secondary"
  ngbTooltip="This option uses the Filter Group UUID copied to the clipboard."
  placement="bottom-right"
  (hidden)="popoverForm.reset()"
  autoClose="outside"
  #fetchPopover="ngbPopover"
  container="body"
>
  Import
</button>

<ng-template #filterGroupPrefixForm>
  <form
    [formGroup]="popoverForm"
    NfFormValidation
    novalidate
    class="d-flex flex-column"
  >
    <nf-form-control label="Filter Group ID">
      <input
        type="text"
        class="form-control"
        formControlName="filterGroupPrefix"
        nfAutofocus
      />
    </nf-form-control>

    <button
      nf-button="create"
      class="align-self-end"
      (click)="onPopoverSubmit()"
    >
      Import
    </button>
  </form>
</ng-template>
